import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { MotionPlugin } from '@vueuse/motion'

import { Amplify } from 'aws-amplify';
import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui';
import amplifyconfig from '../amplifyconfiguration.json';
import { ApiReference } from '@scalar/api-reference';

const app = createApp(App)

// Registrar o componente ApiReference globalmente
app.component('ApiReference', ApiReference);

Amplify.configure(amplifyconfig);

// I18n: aplicar traduções e overrides para português
I18n.putVocabularies(translations);
I18n.setLanguage('pt');
I18n.putVocabulariesForLanguage('pt', {
  'Email': 'E-mail',
  'Password': 'Senha',
  'Login': 'Login',
  'Logout': 'Logout',
  'Register': 'Registrar',
  'Forgot Password': 'Esqueceu a senha?',
  'Sign In': 'Entrar',
  'Sign Up': 'Registrar',
  'Reset Password': 'Redefinir Senha',
  'Enter your email': 'Digite seu e-mail',
  'Code': 'Código',
});

app.use(createPinia())
app.use(router)
app.use(MotionPlugin)

app.mount('#app')
